export default "__VITE_ASSET__3e415d3d__"